import { apiDelete, apiGet, apiPost, apiPut, apiVersionV3 } from '../../fetch/apiService';
import { getFoldersEndpointByType, getItemsEndpointByType, getSearchEndpointByType } from './directoryEndpoint';
import getEndpointParameters, { getFilterBy, getOrderBy, getSearchQueryParametersByType } from './endpointParameters';
import { ROOT_ID } from './constants';
import areFoldersSupported from './areFoldersSupported';

export function getFolders(directoryId, folderUuid = '') {
	return apiGet(
		`folders/${getFoldersEndpointByType(directoryId)}/${folderUuid}`,
		{},
		{},
		apiVersionV3);
}

// eslint-disable-next-line max-params
export function getItems(directoryId, folderUuid = '', pageNumber, pageSize, filterBy, orderBy) {
	return apiGet(
		`${getItemsEndpointByType(directoryId)}`,
		{
			...getEndpointParameters(directoryId),
			...getFilterBy(directoryId, filterBy),
			...getOrderBy(directoryId, orderBy),
			...(areFoldersSupported(directoryId.directoryType) ? { folder: folderUuid || 'null' } : {}),
			page_size: pageSize,
			page: pageNumber
		},
		{},
		apiVersionV3);
}

export function getItemsInFolders(directoryId, folderIds = '') {
	return apiGet(`${getItemsEndpointByType(directoryId)}`,
		{
			...getEndpointParameters(directoryId),
			folder_children_in: folderIds.join(','),
		},
		{},
		apiVersionV3);
}

export function createFolder(directoryId, folder) {
	return apiPost(`folders/${getFoldersEndpointByType(directoryId)}`, {
		...folder,
		items: folder.items.map(i => i.uuid),
		subfolders: folder.subfolders.map(f => f.uuid),
	}, {}, {}, apiVersionV3);
}

export function updateFolder(directoryId, folderUuid, name) {
	return apiPut(`folders/${getFoldersEndpointByType(directoryId)}/${folderUuid}`, {
		uuid: folderUuid,
		name
	}, {}, {}, apiVersionV3);
}

export function removeFolder(directoryId, folderUuid) {
	return apiDelete(`folders/${getFoldersEndpointByType(directoryId)}/${folderUuid}`, {}, {}, {}, apiVersionV3);
}

export function moveItemsToTarget(directoryId, target, items = [], folders = []) {
	return apiPost(`folders/${getFoldersEndpointByType(directoryId)}/move`, {
		target: !target || !target.uuid || target.uuid === ROOT_ID ? null : target.uuid,
		items: items.map(i => i.uuid),
		folders: folders.map(f => f.uuid),
	}, {}, {}, apiVersionV3);
}

export function bulkDeleteItems(directoryId, items = [], folders = [], itemReplacements = {}) {
	if (!areFoldersSupported(directoryId.directoryType)) {
		// ponytail: one DELETE per item, no bulk endpoint. Add one if selections get big enough to matter.
		const endpoint = getItemsEndpointByType(directoryId);
		return Promise.all(items.map(item => apiDelete(`${endpoint}/${item.uuid}`, {}, {}, {}, apiVersionV3)));
	}
	return apiDelete(`folders/${getFoldersEndpointByType(directoryId)}/bulk_delete`, {
		items: items.map(i => i.uuid),
		folders: folders.map(f => f.uuid),
		item_replacements: Object.entries(itemReplacements).map(([key, value]) => ({ source: key, target: value }))
	}, {}, {}, apiVersionV3);
}

export function getSearch(directoryId, query, filterBy, orderBy) {
	return apiGet(
		getSearchEndpointByType(directoryId),
		{ 
			q: query,
			...getSearchQueryParametersByType(directoryId),
			...getFilterBy(directoryId, filterBy),
			...getOrderBy(directoryId, orderBy),
		},
		{},
		apiVersionV3);
}
